interface IUseSEOListTemplateProps {
  currentPage: number;
  basePath: string;
  pageTitle: string;
}

interface IUseSEOListTemplateReturn {
  pageTitleWithPagination: string;
  ampPathVersionWithPagination: string;
  canonicalPathWithPagination: string;
}

export const useSEOListTemplate = ({
  basePath,
  currentPage = 1,
  pageTitle,
}: IUseSEOListTemplateProps): IUseSEOListTemplateReturn => {
  const createPaginationTitle = (title: string, page?: number) =>
    `${title}${page > 1 ? ` | Página ${page}` : ''} | Mais Retorno.`;

  const createPaginationUrl = (url: string, pageNumber: number): string => {
    const pagination = pageNumber > 1 ? `/page/${pageNumber}` : '';

    return `${url}${pagination}`;
  };

  return {
    pageTitleWithPagination: createPaginationTitle(pageTitle, currentPage),
    ampPathVersionWithPagination: createPaginationUrl(
      `${basePath}/amp`,
      currentPage
    ),
    canonicalPathWithPagination: createPaginationUrl(basePath, currentPage),
  };
};
